import { DailyTimecardModelBase }                from '../../timecard/DailyTimecardModel';
import timecardTestEditTimecardsModel            from './TimecardTestEditTimecardsModel';
import { TimecardModelBase }                     from '../../timecard/TimecardModel';

class TimecardTestDailyTimecardModel extends DailyTimecardModelBase {
  constructor() {
    super();
  }

  get timecardModel(): TimecardModelBase {
    return timecardTestEditTimecardsModel;
  }

  executeTransition = async(_event: string) => {
  };
}

const timecardTestDailyTimecardModel = new TimecardTestDailyTimecardModel();
export default timecardTestDailyTimecardModel;
